import { render, staticRenderFns } from "./GeneralHeader.vue?vue&type=template&id=74e2070c&scoped=true"
import script from "./GeneralHeader.vue?vue&type=script&lang=js"
export * from "./GeneralHeader.vue?vue&type=script&lang=js"
import style0 from "./GeneralHeader.vue?vue&type=style&index=0&id=74e2070c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e2070c",
  null
  
)

export default component.exports